module.exports = __webpack_public_path__ + "img/morning.be5030ca.webp";